__turbopack_context__.v({
  "benefit": "PlasmicFeaturesCard-module__-GJ_Aq__benefit",
  "bottom": "PlasmicFeaturesCard-module__-GJ_Aq__bottom",
  "h3": "PlasmicFeaturesCard-module__-GJ_Aq__h3",
  "image": "PlasmicFeaturesCard-module__-GJ_Aq__image",
  "img__z2Tfa": "PlasmicFeaturesCard-module__-GJ_Aq__img__z2Tfa",
  "p": "PlasmicFeaturesCard-module__-GJ_Aq__p",
  "top": "PlasmicFeaturesCard-module__-GJ_Aq__top",
});
